(function () {
    'use strict';

    function mdTheme($rootScope) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                $rootScope.$currentTheme = attrs['mdTheme'];
            }
        };
    }

    mdTheme.$inject = ['$rootScope'];

    angular.module('ecap.common').directive('mdTheme', mdTheme);
})();